import React from "react";
import UserLoginPanel from "../UserLoginPanel";

const UserManagementPanel = () => {
  return <UserLoginPanel />;
};

export default UserManagementPanel;
